import { FC } from "react";
import styles from "./FileTypeIcon.module.less";

const EXT_COLORS: Record<string, string> = {
    pdf: "#E5252A",
    doc: "#2B579A",
    docx: "#2B579A",
    xls: "#217346",
    xlsx: "#217346",
    csv: "#217346",
    ppt: "#D24726",
    pptx: "#D24726",
    txt: "#6B7280",
    png: "#8B5CF6",
    jpg: "#8B5CF6",
    jpeg: "#8B5CF6",
    gif: "#8B5CF6",
    svg: "#8B5CF6",
    zip: "#F59E0B",
    rar: "#F59E0B",
};

const DEFAULT_COLOR = "#6B7280";

function getExtension(filename: string): string {
    const dot = filename.lastIndexOf(".");
    return dot >= 0 ? filename.substring(dot + 1).toLowerCase() : "";
}

interface FileTypeIconProps {
    filename: string;
}

export const FileTypeIcon: FC<FileTypeIconProps> = ({ filename }) => {
    const ext = getExtension(filename);
    const color = EXT_COLORS[ext] || DEFAULT_COLOR;

    return (
        <div className={styles.icon} style={{ backgroundColor: color }}>
            <span className={styles.ext}>{ext || "?"}</span>
        </div>
    );
};
